import { gql } from '@apollo/client'

export const GET_REVIEWS_QUERY = gql`
  query getReviewsQuery($where: String!, $sorting: String!, $limit: Int!) {
    reviews(where: $where, sort: [$sorting], limit: $limit) {
      count
      total
      results {
        id
        authorName
        text
        title
        rating
        createdAt
        lastModifiedAt
        custom {
          customFieldsRaw {
            name
            value
          }
        }
      }
    }
  }
`

export const GET_REVIEW_PRODUCT_INFO = gql`
  query getReviewProductInfo($sku: String!) {
    product(sku: $sku) {
      id

      masterData {
        current {
          masterVariant {
            attributesRaw(includeNames: ["productDetailPageUrl"]) {
              name
              value
            }
            images {
              url
            }
          }
          nameAllLocales {
            locale
            value
          }
        }
      }
    }

    state(key: "review-published") {
      id
    }
  }
`
